import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Stack,
  } from "@mui/material";
  import { useState, useContext } from "react";
  import { useParams } from "react-router-dom"; 
  import { doc, updateDoc } from "firebase/firestore";
  import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
  import { db, storage } from "../../../firebase";
  import { EventContext } from "../../../pages/Dashboard";
  
  const SponsorEditModal = ({ open, onClose, sponsor, onUpdated }) => {
    const [name, setName] = useState(sponsor?.sponsorName || "");
    const [logoFile, setLogoFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    const {eventID} = useParams();
  
    const uploadLogo = async () => {
      if (!logoFile || !eventID) return null;
      const fileRef = ref(
        storage,
        `sponsors/${eventID}/${Date.now()}_${logoFile.name}`
      );
      const snap = await uploadBytes(fileRef, logoFile);
      return await getDownloadURL(snap.ref);
    };
  
    const handleSubmit = async () => {
      setUploading(true);
      try {
        let logoURL = sponsor.sponsorLogo;
        if (logoFile) {
          logoURL = await uploadLogo();
        }
  
        const sponsorRef = doc(db, "events", eventID, "sponsors", sponsor.id);
        await updateDoc(sponsorRef, {
          sponsorName: name,
          sponsorLogo: logoURL,
        });
  
        onUpdated?.();
        onClose?.();
      } catch (err) {
        console.error("Error updating sponsor:", err);
      } finally {
        setUploading(false);
      }
    };
  
    return (
      <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle>Edit Sponsor</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              label="Sponsor Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setLogoFile(e.target.files[0])}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} disabled={uploading} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default SponsorEditModal;
  